import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import { GasSize } from '../../../core/sizes/gas-size.enum';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasCard } from '../gas-card.namespace';

@Component({
  selector: 'gas-card-footer',
  templateUrl: './gas-card-footer.component.html',
  styleUrls: ['./gas-card-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasCardFooterComponent {

  @Input()
  public text: string;

  @Input()
  public type: GasCard.ButtonType;

  @Input()
  public inputTemplate: TemplateRef<void>;

  @Input()
  public icon: GasIcon.Icons;

  @Input()
  public iconSize: GasSize;

  @Output()
  public onClick = new EventEmitter();

  @HostBinding('class._default')
  public get classDefault(): boolean {
    return this.checkDefaultType(GasCard.ButtonType.Default) ? true : false;
  }

  @HostBinding('class._brand')
  public get classBrand(): boolean {
    return this.checkType(GasCard.ButtonType.Brand) ? true : false;
  }

  @HostBinding('class._positive')
  public get classPositive(): boolean {
    return this.checkType(GasCard.ButtonType.Positive) ? true : false;
  }

  @HostBinding('class._destructive')
  public get classDestructive(): boolean {
    return this.checkType(GasCard.ButtonType.Destructive) ? true : false;
  }

  constructor() { }

  private checkType(type: GasCard.ButtonType): boolean {
    return !this.inputTemplate && (this.type === type);
  }

  private checkDefaultType(type: GasCard.ButtonType): boolean {
    return !this.inputTemplate && (this.type === type || !this.type);
  }
}
